import React from 'react';
import logo from '../Assets/img/logo-small.png';

const PdfTemplate = ({ data }) => {
  return (
    <div style={{ margin: '5px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <img src={logo} alt="Logo" style={{ width: '50px', marginBottom: '5px' }} />
      </div>
      <h4 style={{ textAlign: 'center', color: '#581F37' }}>
        <strong>{localStorage.getItem('username')}</strong>
      </h4>
      <h5 style={{ textAlign: 'center', color: '#581F37', marginBottom: '20px' }}>Student Course Registration Details</h5>
      
      <div style={{ pageBreakInside: 'avoid', breakInside: 'avoid', marginBottom: '20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', backgroundColor: '#581F37', color: 'white', fontWeight: 'bold', border: '2px solid #000' }}>
            <div style={{ flex: '10%', padding: '12px', border: '1px solid #000' }}>Sl No</div>
            <div style={{ flex: '20%', padding: '12px', border: '1px solid #000' }}>APAAR</div>
            <div style={{ flex: '20%', padding: '12px', border: '1px solid #000' }}>Name</div>
            <div style={{ flex: '50%', padding: '12px', border: '1px solid #000' }}>Courses</div>
          </div>
          
          {data.length > 0 ? (
            data.map(([apaarId, studentDetails], index) => (
              <div key={apaarId} style={{ 
                display: 'flex', 
                pageBreakInside: 'avoid', 
                backgroundColor: 'white', 
                color: 'black', 
                border: '2px solid #000'
              }}>
                <div style={{ flex: '10%', padding: '10px', borderRight: '1px solid #000' }}>{index + 1}</div>
                <div style={{ flex: '20%', padding: '10px', borderRight: '1px solid #000' }}>{apaarId}</div>
                <div style={{ flex: '20%', padding: '10px', borderRight: '1px solid #000' }}>{studentDetails.studentname}</div>
                <div style={{ flex: '50%', padding: '10px' }}>
                  {studentDetails.courses.map((course, courseIndex) => (
                    <div key={courseIndex} style={{ marginBottom: '5px' }}>
                      {course.paper_identifier}: {course.course_name}
                      {course.student_college_type === 'external' && (
                        <span style={{ 
                          backgroundColor: '#dc3545',
                          color: 'white',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          fontSize: '10px',
                          marginLeft: '5px'
                        }}>
                          External
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div style={{ 
              padding: '10px', 
              textAlign: 'center', 
              border: '2px solid #000'
            }} >
              No data available
            </div>
          )}
        </div>
      </div>
      
      <div style={{ 
        marginTop: 'auto',
        paddingTop: '20px',
        marginBottom: '20px',
        textAlign: 'center',
        fontSize: '11px',
        color: '#333',
        borderTop: '1px solid #ccc',
      }}>
        <p><strong>Disclaimer:</strong> This document is generated to examine the students' course registration status. The document is not intended to be considered as an official document expressing approval.</p>
      </div>
    </div>
  );
};

export default PdfTemplate;